import React from 'react';
import { InlineWidget } from 'react-calendly';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';

const RequestDemoPage = () => {
  const widgetStyles = {
    height: '700px',
  };

  return (
    <div>
      <Header />
      <div className="bg-gradient-to-tr from-[#35a89d] to-[#e0f2f1] mx-auto px-6 pt-40 pb-5">
        <h1 className="text-5xl font-bold text-center text-gray-800 mb-8">Schedule a Meeting</h1>
        <InlineWidget 
          url="https://calendly.com/info-techvelly/new-meeting-1" 
          styles={widgetStyles}
        />
      </div>
      <Footer />
    </div>
  );
};

export default RequestDemoPage;